import { PagedResult } from 'types/api';
import { OrderStatus, OrderSummary } from 'types/order';
import catalogConfigService from 'services/catalogConfigService';

interface StoreOrderSummaryApi {
  orderId?: number;
  OrderId?: number;
  orderDate?: string;
  OrderDate?: string;
  status?: string;
  Status?: string;
  total?: number;
  Total?: number;
  itemCount?: number;
  ItemCount?: number;
}

const KNOWN_STATUSES: OrderStatus[] = [
  'pending',
  'confirmed',
  'processing',
  'prepared',
  'shipped',
  'delivered',
  'invoiced',
  'cancelled',
];

export const mapOrderStatus = (raw?: string): OrderStatus => {
  const value = (raw || 'pending').toLowerCase() as OrderStatus;
  return KNOWN_STATUSES.includes(value) ? value : 'pending';
};

export const mapStoreOrderSummary = (data: StoreOrderSummaryApi): OrderSummary => {
  const id = String(data.orderId ?? data.OrderId ?? '');
  return {
    id,
    orderNumber: id,
    createdAt: data.orderDate || data.OrderDate || new Date().toISOString(),
    status: mapOrderStatus(data.status || data.Status),
    total: Number(data.total ?? data.Total ?? 0),
    currency: catalogConfigService.getDefaultCurrency(),
    itemCount: Number(data.itemCount ?? data.ItemCount ?? 0),
  };
};

export const asOrderList = (data: unknown): OrderSummary[] => {
  if (Array.isArray(data)) {
    return data.map((item) => mapStoreOrderSummary(item as StoreOrderSummaryApi));
  }
  if (data && typeof data === 'object' && Array.isArray((data as PagedResult<StoreOrderSummaryApi>).items)) {
    return (data as PagedResult<StoreOrderSummaryApi>).items.map(mapStoreOrderSummary);
  }
  return [];
};
